<template>
    <div class="leads">
        <Lead :key="lead.id" v-for="lead in leads" :lead="lead" :offerLeadStatus="offerLeadStatus" :tags="tags" />
    </div>
</template>

<script>
import Lead from '../Lead.vue'

export default {
  components: { Lead },

    props: {
        leads: {
            type: Array,
            required: true
        },
        offerLeadStatus: {
            type: Array,
            required: true
        },
        tags: {
            type: Array,
            required: true
        }
    }
}
</script>

<style scoped>
    p { 
        margin: 0;    
    }

    .leads {
        display: flex;
        flex-direction: column;
        gap: 20px;;
    }
</style>


// WEBPACK FOOTER //
// src/components/Prospection/Cards/LeadsCard.vue